import React, { useMemo } from "react";
import { Text, Group } from "react-konva";
import { DisplaySize } from "../types/editorTypes";

interface WatermarkProps {
  displaySize: DisplaySize;
  text?: string;
  fontSize?: number;
  opacity?: number;
  rotation?: number;
  spacing?: number;
}

/**
 * 斜め透かし（ウォーターマーク）コンポーネント
 * 画像全体に繰り返しパターンで「らくらくデコルーム」を表示
 */
export const Watermark: React.FC<WatermarkProps> = ({
  displaySize,
  text = "らくらくデコルーム",
  fontSize = 36,
  opacity = 0.15,
  rotation = -30,
  spacing = 200,
}) => {
  // ウォーターマークの位置を計算
  const watermarks = useMemo(() => {
    if (displaySize.width <= 0 || displaySize.height <= 0) {
      return [];
    }

    const positions: { x: number; y: number; key: string }[] = [];

    // 回転を考慮して広めの範囲にウォーターマークを配置
    const padding = Math.max(displaySize.width, displaySize.height);
    const startX = displaySize.offsetX - padding / 2;
    const startY = displaySize.offsetY - padding / 2;
    const endX = displaySize.offsetX + displaySize.width + padding / 2;
    const endY = displaySize.offsetY + displaySize.height + padding / 2;

    let index = 0;
    for (let y = startY; y < endY; y += spacing) {
      for (let x = startX; x < endX; x += spacing) {
        positions.push({
          x,
          y,
          key: `watermark-${index++}`,
        });
      }
    }

    return positions;
  }, [displaySize, spacing]);

  if (displaySize.width <= 0 || displaySize.height <= 0) {
    return null;
  }

  return (
    <Group
      clipX={displaySize.offsetX}
      clipY={displaySize.offsetY}
      clipWidth={displaySize.width}
      clipHeight={displaySize.height}
    >
      {watermarks.map(({ x, y, key }) => (
        <Text
          key={key}
          x={x}
          y={y}
          text={text}
          fontSize={fontSize}
          fontFamily="sans-serif"
          fontStyle="bold"
          fill="#888888"
          opacity={opacity}
          rotation={rotation}
          listening={false}
        />
      ))}
    </Group>
  );
};

export default Watermark;
